module.exports = __webpack_public_path__ + "img/1489526376.53b75a8d.jpg";